/* eslint-disable */
// ─── Yoga style tokens ────────────────────────────────────────────────────────
// The same style→emoji map was copy-pasted into five files (BookingFlow,
// Mapview, Phase3Components, TeacherProfile, SearchBar), each free to drift.
// This is the single definition, and it uses a coloured dot rather than emoji —
// the convention the school and admin dashboards already follow.
//
// Why a dot beats an emoji here: 🔥 for Vinyasa and 🦁 for Power are arbitrary
// (nothing about Power yoga is leonine), they render differently on every
// platform, and their colours are fixed by the emoji font rather than by the
// palette. A dot in the style's own colour carries the same "these are
// different things" signal, consistently, at any size.
export const STYLE_COLORS = {
  Hatha:       "#F59E0B",
  Vinyasa:     "#EF4444",
  Yin:         "#818CF8",
  Kundalini:   "#A855F7",
  Meditation:  "#3B82F6",
  Ashtanga:    "#10B981",
  Restorative: "#22C55E",
  Power:       "#F97316",
  Prenatal:    "#EC4899",
  "Sound Healing": "#14B8A6",
  Retreat:     "#7C8B6F",
};

export const styleColor = (style) => STYLE_COLORS[style] || "#B5703F";

export const StyleDot = ({ style, size = 8, ring = false, ...rest }) => (
  <span
    aria-hidden="true"
    style={{
      display: "inline-block", width: size, height: size, borderRadius: "50%",
      background: styleColor(style), flexShrink: 0,
      marginRight: 5, verticalAlign: "middle",
      boxShadow: ring ? `0 0 0 ${Math.max(2, size / 4)}px ${styleColor(style)}22` : "none",
    }}
    {...rest}
  />
);
